/**
 * The app's motion vocabulary, in one place.
 *
 * Every entrance in Flow is the same gesture — a short rise with a fade, eased
 * out — so screens, cards and popovers feel like one system rather than each
 * component's own idea of a transition. Exits are faster than entrances: an
 * element leaving should not make anyone wait for it.
 *
 * Numbers here are gsap's: seconds, and pixels for the rise.
 */
export const MOTION = {
  /** Entrance: how long, how it eases, how far it travels. */
  duration: 0.6,
  ease: "power2.out",
  /** Exit: shorter, and eased the other way so it accelerates away. */
  exitDuration: 0.25,
  exitEase: "power2.in",
  /** Rise for a small element — a card, a banner, a popover. */
  rise: 12,
  /** Rise for a whole screen, which needs a touch more travel to read. */
  pageRise: 16,
  /** Gap between siblings entering one after another. */
  stagger: 0.18,
} as const;

/** Whether the viewer asked the system for less movement. */
export const prefersReducedMotion = () =>
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;
